import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GraphNode } from '../interfaces/graph-node.interface';

@Injectable({ providedIn: 'root' })
export class PreviewResource {
  private readonly baseUrl = environment.apiUrl + '/nodes';

  constructor(private http: HttpClient) {}

  /**
   * Get preview nodes for a map (3-level depth limit, minimal data)
   */
  getPreviewNodes(mapId: string): Observable<GraphNode[]> {
    return this.http.get<GraphNode[]>(`${this.baseUrl}/map/${mapId}/preview`);
  }
}
